import { Attachment, AttachmentChangedEvent, IActivityAttachment, IAttachment } from "../../../base/common/attachment";
import { IHierarchyNode, NodeFlags } from "./hierarchy";
import { HierarchyNode } from "./hierarchyService";

const inactiveIconName = "icon-inactive";
const activeIconName = "icon-active";

export class ActivityAttachment extends Attachment implements IActivityAttachment {

    static getIfExists(object: object) {
        const node = HierarchyNode.get(object);
        if (node) {
            const attachment = node.attachments.find(att => att instanceof ActivityAttachment);
            if (attachment) {
                return attachment as ActivityAttachment;
            }
        }
        return null;
    }

    static notifyForObject(object: object) {
        const node = HierarchyNode.get(object);
        if (node) {
            const attachment = node.attachments.find(att => att instanceof ActivityAttachment);
            if (attachment) {
                attachment.notifyActivity();
            }
        }
    }
    static isActive(object: object) {
        const node = HierarchyNode.get(object);
        if (node) {
            const attachment = node.attachments.find(att => att instanceof ActivityAttachment);
            if (attachment) {
                return attachment.active;
            }
        }
        return false;
    }

    readonly type = 'activity';


    get active() {
        return (Date.now() - this._lastActiveTime) < this._timeoutDuration;
    }
    notifyActivity() {
        this._lastActiveTime = Date.now();
        this._updateState(true);
        // Schedule new inactive timeout
        if (this._timeoutId) clearTimeout(this._timeoutId);
        this._timeoutId = setTimeout(this._onTimeout, this._timeoutDuration * 1.2);
    }

    constructor(protected readonly node: IHierarchyNode) {
        super('activity', undefined, "", inactiveIconName);
        this._updateState(false);
        // window.requestAnimationFrame(() => this._updateState(false));
    }


    private _lastActiveTime: number = 0;
    private _timeoutId: any = null;
    private _timeoutDuration: number = 50;

    private _onTimeout = () => {
        this._updateState(false);
    }

    private _lastActiveState: boolean | undefined = undefined;

    private _updateState(isActive: boolean) {
        if (isActive !== this._lastActiveState) {
            this._lastActiveState = isActive;
            this._icon = isActive ? activeIconName : inactiveIconName;
            this._description = isActive ? "The object is active!" : "The object is inactive!";
            this._visible = false; // hiding the attachment (we visualize this in another way in the UI, this attachment is only storing the state)
            this._onDidChange.fire({ attachment: this } as AttachmentChangedEvent);
        }

        if (!isActive) HierarchyNode.enableFlag(this.node, NodeFlags.Inactive);
        else HierarchyNode.disableFlag(this.node, NodeFlags.Inactive);
    }

}